import { create } from "zustand";

/**
 * ลูกค้ามีใบ K Biz อยู่บนจอไหม (ตั้งแต่ออกใบจนกดกลับไปหน้ากรอกยอด รวมหน้าสำเร็จ/หมดเวลา)
 *
 * ช่อง K Biz ถูกซ่อนเมื่อ SayPay หลุดล็อกอิน (health) — แต่ซ่อนแค่สำหรับการเปิดใบใหม่
 * คนที่ถือใบอยู่ต้องยังเห็นแผง + poll + ปุ่มเร่งยอด และหน้าฝากต้องไม่ดีดเขาไปช่องอื่น
 * KbizTopup เป็นคนตั้งค่านี้ · หน้าฝากอ่านไปตัดสินว่ายังโชว์ช่อง K Biz ไหม
 *
 * ไม่ล้างตอน KbizTopup unmount — สลับไปดูช่องอื่นแล้วกลับมา ใบยังเป็นของเขาอยู่
 */
type KbizSessionState = {
  active: boolean;
  setActive: (active: boolean) => void;
  /**
   * มีใบฝาก (K Biz / พร้อมเพย์ / ทรู) กางอยู่บนจอไหม — ใช้คนละเรื่องกับ active
   *
   * active บอกว่า "ใบเป็นของช่อง K Biz" หน้าฝากเลยพากลับไปช่องนั้น
   * ส่วนอันนี้บอกแค่ "กำลังอ่านใบอยู่" ไม่ว่าช่องไหน กระเป๋าเงินจะได้พับยอดเงิน
   * กับแท็บวิธีฝากทิ้งชั่วคราว ไม่งั้นจอมือถือยาวเกิน ลูกค้าเลื่อนหาปุ่มไม่เจอ
   */
  ticketOpen: boolean;
  setTicketOpen: (open: boolean) => void;
  /**
   * "ใครเป็นคนโอน?" ที่ลูกค้าเลือกไว้ — เก็บในหน่วยความจำอย่างเดียว (ไม่ลง localStorage)
   * ชื่อคนอื่นเป็นข้อมูลส่วนตัว ไม่ควรค้างในเครื่องที่อาจใช้ร่วมกัน · รีเฟรชแล้วกลับเป็น "ตัวเอง"
   */
  payerMode: "self" | "other";
  payerName: string;
  setPayer: (mode: "self" | "other", name: string) => void;
};

export const useKbizSessionStore = create<KbizSessionState>((set) => ({
  active: false,
  setActive: (active) => set((state) => (state.active === active ? state : { active })),
  ticketOpen: false,
  setTicketOpen: (ticketOpen) =>
    set((state) => (state.ticketOpen === ticketOpen ? state : { ticketOpen })),
  payerMode: "self",
  payerName: "",
  setPayer: (payerMode, payerName) => set({ payerMode, payerName }),
}));
